import React from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "../Layout/index";
import { MainRoutes, ExternalRoutes } from "./allRoutes";
import ExternalPages from "../pages/External/External";

const Index = () => {
  return (
    <React.Fragment>
      <Routes>
        <Route>
          {MainRoutes.map((route, idx) => (
            <Route path={route.path} element={
              <Layout>
                {route.component}
              </Layout>
            } key={idx} />
          ))}
        </Route>
        <Route>
          {ExternalRoutes.map((route, idx) => (
            <Route path={route.path} element={
              <ExternalPages>
                {route.component}
              </ExternalPages>
            } key={idx} />
          ))}
        </Route>
      </Routes>
    </React.Fragment>
  );
};

export default Index;



